<template>
<div>
  <v-toolbar color="white" elevation="0">
       <div class="col-12"><h2>Reports</h2></div>
    </v-toolbar>
  <v-card>
    <v-row>
      <v-col
        cols="6"
        sm="6"
        md="6"
        v-for="(item, index) in reports"
        :key="index"
      >
      <!-- {{reports}} -->
        <report-list
          :id="item.id"
          :date="item.date"
          :time="item.time"
          :title="item.title"
          :address="item.address"
          :body="item.body"
          :phoneNumber="item.phoneNumber"
          :status="item.status"
          :image="item.image"
        />
      </v-col>
    </v-row>
  </v-card>
</div>
</template> 
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import moment from "moment";
import ReportList from "../components/ReportList";

export default {
  async created() {
        await this.fetchAllReports();
  },
  components: {
    ReportList,
  },
    computed: {
    ...mapFields("reports", ["allReports"]),
  },
    data() {
    return {
      reports: [],
    };
  },
    methods: {
    ...mapActions("reports", ["fetchAllReports"]),
  },
    watch: {
    allReports: {
      immidate: true,
      handler(value) {
        // console.log(value);
        // 
        value.map((report, index) => {
          var iso, utc, date, time, image;
          // The new announcement dates created on from Admin will always
          // have Number Timestamp thus separate old news creations from new ones
          if (!report.date.seconds) {
            iso = moment.utc(report.date * 1000).format();
            utc = moment(iso)
              .format("dddd, MMMM Do YYYY, h:mm:ss a")
              .split(",");
            date = utc[0] + utc[1].toString();
            time = utc[2].toString();
          } else {
            // Convert the TimeStamp date to appropriate Date and Time
            iso = moment.utc(report.date.seconds * 1000).format();
            utc = moment(iso)
              .format("dddd, MMMM Do YYYY, h:mm:ss a")
              .split(",");
            date = utc[0] + utc[1].toString();
            time = utc[2].toString();
          }
          this.reports.push({
            id: report.userId,
            title: report.reportType,
            body: report.description,
            address: report.address.city,
            phoneNumber: report.address.phoneNumber,
            date: date,
            time: time,
            status: report.status,
            image: report.image,
          });
        });
      },
    },
  },
}
</script>